import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ShoppingCart from '@material-ui/icons/ShoppingCart';

import {
  Paper,
  Typography
} from '@material-ui/core';
import '../../assets/stylesheets/Closet.css';

class CartIcon extends Component {
  render() {
    const { itemsTotal, toggleCart } = this.props;
    return (
      <Paper className={`closetIcon ${itemsTotal > 0 ? 'full' : 'empty'}`} onClick={() => toggleCart()}>
        <ShoppingCart />
        <Typography className="itemsTotal" variant="h6" noWrap>
          {itemsTotal}
        </Typography>
      </Paper>
    )
  }
}

const mapStateToProps = state => ({
  itemsTotal: state.closetCart.total,
});

CartIcon.propTypes = {
  itemsTotal: PropTypes.number.isRequired,
  toggleCart: PropTypes.func.isRequired,
}

export { CartIcon as CartIconNoConnect }
export default connect(mapStateToProps)(CartIcon);